import Header from './Header'
import Card from './Card'
import Corkboard from './Corkboard'
import MissionCard from './MissionCard'
import Chalkboard from './Chalkboard'
import EmailCard from './EmailCard'
import InteractivesArea from './InteractivesArea'
import Interactive from './Interactive'
import Nelson from './Nelson'

const Intro = ({ onScreenUpdate }) => {
  return (
    <div className="mainContainer">
      <Header onScreenUpdate={onScreenUpdate} />
      <Chalkboard>
        <div className="chalkboardHeader LithosPro welcomeHeader ">
          Welcome to Equine Science 4 Kids!
        </div>
        <div className="chalkboardContent emptyBoard">
          <p>
            Would school be more fun if there were horses in your classroom? How
            about horses in your gym class? And even in your lunch room? Hey,
            it's not a dream! It's the Rutgers Equine Science Center.
          </p>
          <p>
            We go to school with horses every day! We've learned a lot about
            keeping them happy, healthy and strong, and keeping their
            environment clean. And now you can too. Just saddle up and click
            around!
          </p>
        </div>
      </Chalkboard>
      <InteractivesArea>
        <Interactive cat={'welcome'} itemName={'gift'} alt={'a wrapped gift'} />
        <Interactive
          cat={'welcome'}
          itemName={'FunOnTheFarm_logo'}
          alt={'Fun on the Farm logo'}
        />
        <Interactive
          cat={'welcome'}
          itemName={'ExercisingHorsepower-square-logo'}
          alt={'Exercising Horsepower logo'}
        />
      </InteractivesArea>
      <Corkboard>
        <MissionCard />
        <EmailCard />

        <Card className="linksCard">
          <div className="cardTitle linksTitle">Links</div>
          <div>
            <a
              href="pages/main/nelsonBio.html"
              target="_blank"
              rel="noreferrer"
            >
              Bio
            </a>
          </div>
          <div>
            <a
              href="https://esc.rutgers.edu/blog/"
              target="_blank"
              rel="noreferrer"
            >
              Blog
            </a>
          </div>
          <div>
            <a
              href="pages/main/joinFanClub.html"
              target="_blank"
              rel="noreferrer"
            >
              Join the fanclub
            </a>
          </div>
        </Card>
      </Corkboard>
      <Nelson screen={'intro'} />
    </div>
  )
}

export default Intro
